import { AgentStatuses } from '@insurance/types'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'

export const statusList = Object.values(AgentStatuses)

export const statusOptions = (t: TFunction): SelectProps['options'] =>
  statusList.map((value) => ({
    label: t(value),
    value
  }))
